import { REFRESH_TOKEN, TOKEN, USER_ROLES } from '../common/constants/localStorage';
import { isImpersonationTab } from './impersonationSession';

const AUTH_KEYS = [TOKEN, REFRESH_TOKEN, USER_ROLES];

// in an impersonation tab the auth keys live in that tab's sessionStorage; localStorage holds the admin's session
const storageFor = tokenName =>
    AUTH_KEYS.includes(tokenName) && isImpersonationTab() ? window.sessionStorage : window.localStorage;

export const getToken = tokenName => {
    const value = storageFor(tokenName).getItem(tokenName);

    if (value === null || value === 'undefined') {
        return null;
    }
    return JSON.parse(value);
};

export const updateToken = (tokenName, token) => {
    storageFor(tokenName).setItem(tokenName, JSON.stringify(token));
};

export const removeToken = tokenName => {
    storageFor(tokenName).removeItem(tokenName);
};
